import { useEffect, useMemo } from 'react';

export const EXCEL_OPERATION_EVENT = 'excel-operation-loading';

export interface ExcelOperationEventDetail {
  loading: boolean;
  id?: string;
  message?: string;
}

export const setExcelOperationLoading = ({ loading, id = 'default', message }: ExcelOperationEventDetail) => {
  if (typeof window === 'undefined') return;

  window.dispatchEvent(
    new CustomEvent<ExcelOperationEventDetail>(EXCEL_OPERATION_EVENT, {
      detail: { loading, id, message }
    })
  );
};

export const useExcelOperationLoadingSignal = (loading: boolean, message?: string, id?: string) => {
  const resolvedId = useMemo(() => id || `excel-operation-${Math.random().toString(36).slice(2)}`, [id]);

  useEffect(() => {
    setExcelOperationLoading({ loading, id: resolvedId, message });

    return () => {
      setExcelOperationLoading({ loading: false, id: resolvedId });
    };
  }, [loading, message, resolvedId]);
};
